/**
 * Modern Layouters Integration Script
 * This file loads the ES6 ModernLayouters.js and makes it available globally for the TypeScript layouters
 */

// Import the ModernLayouters ES6 module
// @ts-ignore - JavaScript module without TypeScript declarations
import('./modern-layouters.js').then((module: any) => {
    // Make ModernLayouters available globally
    (window as any).ModernLayouters = module.ModernLayouters;
    console.log('🚀 ModernLayouters loaded and available globally:', module.ModernLayouters);
}).catch((error) => {
    console.error('❌ Failed to load ModernLayouters:', error);
});

// For immediate usage, we can also create a promise-based wrapper
export const loadModernLayouters = (): Promise<any> => {
    // @ts-ignore - JavaScript module without TypeScript declarations
    return import('./modern-layouters.js').then((module: any) => {
        (window as any).ModernLayouters = module.ModernLayouters;
        console.log('✅ ModernLayouters module loaded and exposed globally');
        return module.ModernLayouters;
    });
};

// Export type definitions for TypeScript support
export interface ModernLayoutersConfig {
    objectCount: number;
    spacingMode: 'margin' | 'distribute';
    spacing: number;
    orientation: 'aligned' | 'perpendicular';
    upMode: 'world' | 'path';
    flip180: boolean;
    objects?: any[];
    spiralConfig?: {
        spiralTurns: number;
        maxRadius: number;
        growthRate: number;
        startDistance: number;
    };
}

export interface Transform {
    position: { x: number; y: number; z: number };
    rotation: { x: number; y: number; z: number };
    scale: { x: number; y: number; z: number };
}

export interface ModernLayoutersInterface {
    line(config: ModernLayoutersConfig): Transform[];
    circle(config: ModernLayoutersConfig): Transform[];
    spiral(config: ModernLayoutersConfig): Transform[];
    lineAdaptive(config: ModernLayoutersConfig): Transform[];
    circleAdaptive(config: ModernLayoutersConfig): Transform[];
    spiralAdaptive(config: ModernLayoutersConfig): Transform[];
    sphereGrid(config: ModernLayoutersConfig): Transform[];
    planeGrid(config: ModernLayoutersConfig): Transform[];
    sphereHex(config: ModernLayoutersConfig): Transform[];
    sphereHexRings(config: ModernLayoutersConfig): Transform[];
    sphereHexHoneycomb(config: ModernLayoutersConfig): Transform[];
    planeHexRings(config: ModernLayoutersConfig): Transform[];
}

// Global declaration for TypeScript
declare global {
    interface Window {
        ModernLayouters: ModernLayoutersInterface;
    }
}